import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { PHONE_PATH, FACEBOOK_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const WEBSITE_SPELL_NAME = "website";

const FillOrigamiStepProps = {
  previous: PHONE_PATH,
  next: FACEBOOK_PATH,
  question: "Do you have a <%= target %>",
  target: "website",
  spellName: WEBSITE_SPELL_NAME,
  placeholder: "https://example.com",
  required: false,
};

export const WebsiteStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(WebsiteStep);
